import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Projeto } from '../../dto/project';
import { AddDocumentsModalComponent } from '../add-documents-modal/add-documents-modal.component';
import { ConsultaDocumentoDto } from '../../dto/consulta-documento.dto';
import { DocumentoService } from '../../services/documento.service';
import { DocumentoDto } from '../../dto/documento.dto';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { StatusDocumentoComponent } from '../status/status-documento/status-documento.component';

@Component({
  selector: 'app-documents-modal',
  templateUrl: './documents-modal.component.html',
  styleUrl: './documents-modal.component.scss'
})
export class DocumentsModalComponent implements OnInit {
  @ViewChild('exlargeModal') modalListaDocumentos!: TemplateRef<any>;
  @Input() projetoId: string = '';

  public projeto?: Projeto;
  listaDocumentos: DocumentoDto[] = [];
  projetoIdAtual = '';

  podeEditarOrcamento = false;
  podeEditarProposta = false;
  podeEditarProjetoArquiteto = false;
  podeEditarContrato = false; 
  podeEditarEmail = false;
  podeEditarAdicionarDoc = false;

  constructor(
    private router: Router,
    public documentoService: DocumentoService,
    private modalService: NgbModal,
    private authService: AuthService) {}
    
  ngOnInit(): void {
    this.permissaoAdicionarUsuario();
  }

  extraLarge(projetoId: string) {
    this.projetoIdAtual = projetoId;
    this.consularListaDocumentos(projetoId!);

    this.modalService.open(this.modalListaDocumentos, { size: 'xl' });
    //this.projeto = data;
  }
  
  // passa o projeot para add-documents-modal.component
  abrirModalDocumento(){
    const modalRef = this.modalService.open(AddDocumentsModalComponent);
    modalRef.componentInstance.projetoId = this.projetoIdAtual;
  }

  consularListaDocumentos(projetoId: string): void {

    this.documentoService.atualizarLista(projetoId);

    // Depois, nos inscrevemos para receber atualizações em tempo real
    this.documentoService.documentos$.subscribe((documentos) => {
      this.listaDocumentos = documentos;
    });
  }

  redirecionarParaDocumento(event: any):void {

    this.modalService.dismissAll();

    if(event.tipoDocumento === 1)
      this.router.navigate([`/telemarketing/projetos/projeto-arquiteto/${event.id}`]);

    if(event.tipoDocumento === 2){
      this.router.navigate([`/telemarketing/projetos/orcamento/${event.id}`]);
    }

    if(event.tipoDocumento === 3)
      this.router.navigate([`/telemarketing/projetos/proposta-comercial/${event.id}`]);

    if(event.tipoDocumento === 4)
      this.router.navigate([`/telemarketing/projetos/contrato/${event.id}`]);

  }

  atualizarStatusDocumento(event: any): void {
    const modalRef = this.modalService.open(StatusDocumentoComponent);

    modalRef.componentInstance.projetoId = event.projetoId;
    modalRef.componentInstance.codumentoId = event.id;
    modalRef.componentInstance.tipoDocumento = event.tipoDocumento;
    modalRef.componentInstance.statusDocumento = event.statusDocumentoId;
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditarOrcamento = this.authService.verificarPermissao('Doc_Orcamento', 'Editar')
    this.podeEditarProposta = this.authService.verificarPermissao('Doc_Proposta_Comercial', 'Editar')
    this.podeEditarProjetoArquiteto = this.authService.verificarPermissao('Doc_Projeto_Arquiteto', 'Editar')
    this.podeEditarContrato = this.authService.verificarPermissao('Doc_Contrato', 'Editar')
    this.podeEditarEmail = this.authService.verificarPermissao('Prj_Envia_Email', 'Editar')
    this.podeEditarAdicionarDoc = this.authService.verificarPermissao('Doc_Adicionar_Doc', 'Editar')
  }

}